/* ============================================================================
   DEV AASTHA — PDP V2 · REVIEW COLUMN: FAQ KE BARABAR HEIGHT + ANDAR SCROLL
   ----------------------------------------------------------------------------
   Owner (6 Aug 2026):
     "Review section ko scrollable bana do aur height automatic adjust ho, jo
      FAQ ke saath synchronised ho."

   Kaam: review column ki height FAQ ke barabar rakho, SAARE review card dikhao
   (koi chhupao nahi), aur jo neeche bach jaayein wo column ke ANDAR scroll hon
   — page scroll nahi.

   ---------------------------------------------------------------------------
   TEEN VERSION HO CHUKE HAIN — DOBARA MAT GHUMANA
   ---------------------------------------------------------------------------
   v1: FAQ ki lambai naap kar utne hi card dikhao jitne samayein. Chalta tha
       (naapa: 5 -> 2 -> 5), par card poore ke poore gayab hote the.
   v2: Har chip ke liye fixed ginti (all 4, size 1, material 2, gifting 1,
       order 1). Ginti aur height dono theek, par chhupe hue review customer ko
       kabhi dikhte hi nahi the.
   v3 (yahi): kuch mat chhupao — column FAQ jitna lamba, baaki andar scroll.

   ---------------------------------------------------------------------------
   ⚠⚠ SABSE ZAROORI: FAQ KI *NATURAL* HEIGHT NAAPNI HAI, DIKHNE WALI NAHI
   ---------------------------------------------------------------------------
   `.qarow` grid me `align-items: stretch` hai — row ki height DONO me se jo
   lamba ho usse banti hai, aur doosra usi tak khinch jaata hai.

   Pehli koshish me seedha `faqSec.getBoundingClientRect().height` padha gaya
   tha. Wo GALAT tha aur live naap ne pakda: "Size & fit" chip par FAQ ka apna
   content sirf 354px ka hai, par naap 1151 aaya — kyunki review column (5 card,
   ~1155) us waqt lamba tha, row usse ban rahi thi, aur FAQ usi tak khinch gaya
   tha. Us naap se max-height nikaalo to wo hamesha bada hi nikalta hai, koi
   rok lagti hi nahi, aur scroll kabhi shuru nahi hota.

   Ilaaj: naapne se PEHLE reviews ko pal bhar ke liye `max-height: 0` par
   collapse kar do. Tab review column chhota ho jaata hai, row FAQ se banti hai,
   aur `faqSec` ki height = FAQ ka apna asli content. Wahi naap sahi hai.
   `getBoundingClientRect()` khud layout force karta hai, isliye alag se reflow
   trigger karne ki zaroorat nahi.

   Isi collapse ki wajah se koi FEEDBACK LOOP bhi nahi banta: FAQ ki height ab
   reviews par depend nahi karti, wo ek sthir nishana hai.
   ============================================================================ */
(function () {
  var HOST = document.querySelector('[data-da-reviews]');
  if (!HOST) return;

  var MIN_H = 220;
  var deskMQ = window.matchMedia('(min-width: 1000px)');

  function revSec() { return HOST.closest('.sec'); }
  function faqSec() {
    var f = document.querySelector('.qarow .faqsec');
    return f ? f.closest('.sec') : null;
  }

  function showAllCards() {
    Array.prototype.forEach.call(HOST.children, function (c) { c.style.display = ''; });
  }

  function clearAll() {
    var rs = revSec(), fs = faqSec();
    if (rs) rs.style.alignSelf = '';
    if (fs) fs.style.alignSelf = '';
    HOST.style.maxHeight = '';
    HOST.style.overflowY = '';
    HOST.style.overflowX = '';
    HOST.style.alignContent = '';
    HOST.style.scrollbarWidth = '';
    showAllCards();
  }

  function sync() {
    var rs = revSec(), fs = faqSec();
    if (!rs || !fs || !HOST.children.length) return;

    /* Mobile par FAQ aur reviews upar-neeche aate hain, side-by-side nahi —
       wahan na height baandhni hai na scroll. */
    if (!deskMQ.matches) { clearAll(); return; }

    /* ⚠ Koi card chhupana NAHI (v1/v2 me chhupte the). */
    showAllCards();

    /* dono column barabar — grid ka apna stretch chalne do */
    rs.style.alignSelf = '';
    fs.style.alignSelf = '';

    /* ⚠ Ella `.revs` par `align-content: space-between` deta hai. Jagah bachne
       par usse card DOOR-DOOR bikhar jaate hain (do card ho to ek sabse upar,
       ek sabse neeche). `start` se wo upar se line me lagte hain. */
    HOST.style.alignContent = 'start';

    /* ⚠ NAAPNE SE PEHLE COLLAPSE — upar wala comment padho. Bina iske naap
       reviews ki apni lambai lauta deta hai aur scroll kabhi lagta hi nahi. */
    HOST.style.maxHeight = '0px';
    HOST.style.overflowY = 'hidden';

    var faqNatural = fs.getBoundingClientRect().height;

    /* Review column me cards ke ALAWA jo hai: eyebrow, heading, summary line
       aur "Write a review" button. Ye ab collapse ki halat me naape ja rahe
       hain, jo theek hai — inki height cards par depend nahi karti. */
    var gap = parseFloat(getComputedStyle(rs).rowGap);
    if (!isFinite(gap)) gap = 0;

    var kids = Array.prototype.slice.call(rs.children);
    var chrome = 0;
    kids.forEach(function (k) {
      if (k !== HOST) chrome += k.getBoundingClientRect().height;
    });
    if (kids.length > 1) chrome += gap * (kids.length - 1);

    var avail = faqNatural - chrome;
    if (!isFinite(avail) || avail < MIN_H) avail = MIN_H;

    HOST.style.maxHeight = Math.round(avail) + 'px';
    HOST.style.overflowY = 'auto';
    HOST.style.overflowX = 'hidden';

    /* `da-pdp-v2.css` `.dapdp .revs` par `scrollbar-width: none` deta hai (wo
       mobile ki side-scroll patti ke liye hai). Desktop par patli scrollbar
       dikhni chahiye, warna customer ko pata hi nahi chalega ki aur review
       neeche hain. */
    HOST.style.scrollbarWidth = 'thin';
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; sync(); });
  }

  /* FAQ ki lambai badle to dobara naapo. Collapse-then-measure ki wajah se FAQ
     ki height reviews par depend nahi karti, isliye loop nahi banta. */
  if (window.ResizeObserver) {
    var f = faqSec();
    if (f) new ResizeObserver(schedule).observe(f);
  }

  /* chips aur accordion — dono FAQ ki lambai badalte hain. Accordion me
     transition hoti hai, isliye thoda ruk kar dobara. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.fq') && !e.target.closest('.fchip') && !e.target.closest('#faqMore')) return;
    schedule();
    setTimeout(sync, 260);
    setTimeout(sync, 620);
  });

  /* Judge.me apne review baad me daalta hai (da-pdp-v2-judgeme.js unhe `.rev`
     cards me badalta hai) — tab dobara naapo. */
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(HOST, { childList: true });
  }

  window.addEventListener('resize', schedule);
  if (deskMQ.addEventListener) deskMQ.addEventListener('change', schedule);
  window.addEventListener('load', schedule);

  schedule();
  setTimeout(sync, 900);
  setTimeout(sync, 2000);
  setTimeout(sync, 4000);
})();
